import { DataGrid, GridToolbar } from '@material-ui/data-grid';
import { Link, Typography } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { getFormattedDateUTC } from '../../helpers/date-helpers';
import PrimaryColorLoader from '../../PrimaryColorLoader';
import OliveCard from './OliveCard';
import axiosAuth from '../../../utils/axiosWithAuth';
import { useUser } from '../../../contexts/UserContext';

const getEntry = (params) => params.row;

export default function OliveTable({ validations, fetchValidations, filters, order, page, sort }) {

  const [loadingValidations, setLoadingValidations] = useState(true);
  const [selectedValidation, setSelectedValidation] = useState(null);
  const {user} = useUser();

  // Fetch validations on mount or when filter/order change
  // useEffect(() => {
  //   setValidations([]);
  //   setLoadingValidations(true);
  //   fetchValidations({ filter, order }, () => setLoadingValidations(false));
  // }, [fetchValidations, filter, order]);
  useEffect(() => {

    fetchValidations({ filters, order }, () => setLoadingValidations(false));
  }, [filters, order]);

  // Debug logging
  useEffect(() => {
    console.log(validations);
  }, [validations]);

  // Define table columns
  const INITIAL_COLUMNS = [
    { field: 'id', headerName: 'Validation ID', width: 100, hide: true },
    {
      field: 'utility_bill_id',
      headerName: 'Utility Bill ID',
      width: 150,
      renderCell: (params) => {
        const row = getEntry(params);
        return (
          <Link
            target="_blank"
            rel="noopener noreferrer"
            href={`${process.env.REACT_APP_EP_BASE_URL}/admin/utility_bills/${row.utility_bill_id}/edit`}
            className="grid-link"
          >
            {row.utility_bill_id}
          </Link>
        );
      },
    },
    {
      field: 'severity',
      headerName: 'Severity',
      width: 120,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'human_validation_status',
      headerName: 'Validation Status',
      width: 150,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'confidence',
      headerName: 'Confidence (%)',
      width: 130,
      headerAlign: 'center',
      align: 'center',
      valueFormatter: (params) => `${params.value}%`,
    },
    {
      field: 'created_at',
      headerName: 'Created At',
      width: 180,
      valueFormatter: (params) =>
        params.value ? getFormattedDateUTC(params.value) : '',
    },
    {
      field: 'updated_at',
      headerName: 'Updated At',
      width: 180,
      valueFormatter: (params) =>
        params.value ? getFormattedDateUTC(params.value) : '',
    },
    {
      field: 'validated_by_user_id',
      headerName: 'Validated By',
      width: 150,
      valueFormatter: (params) => params.value || 'N/A',
    },
    {
      field: 'archived',
      headerName: 'Archived',
      width: 100,
      headerAlign: 'center',
      align: 'center',
      valueFormatter: (params) => (params.value ? 'Yes' : 'No'),
    },
    {
      field: 'textract_bill_id',
      headerName: 'Textract Bill ID',
      width: 150,
      renderCell: (params) => {
        const row = getEntry(params);
        return (
          <Link
            target="_blank"
            rel="noopener noreferrer"
            href={`/${process.env.REACT_APP_MODE == 'invoiage' ? 'documents' : 'invoiage'}/${row.textract_bill_id}/view`}
            className="grid-link"
          >
            {row.textract_bill_id}
          </Link>
        );
      },
    },
  ];

  const [columns, setColumns] = useState(INITIAL_COLUMNS);

  // Toggle column visibility
  const handleColumnVisibilityChange = (params) => {
    setColumns((current) =>
      current.map((col) =>
        col.field === params.field ? { ...col, hide: !params.isVisible } : col
      )
    );
  };

  // Mark a validation as checked (placeholder for API call)
  const updateValidationStatus = (validationId, newStatus) => {
    console.log(`Marking validation ${validationId} as ${newStatus}`);
    const requestUrl = `/${user.admin ? "admin/textract_bills" : "documents"}/ai_validations/${validationId}/`
    console.log("About to make API request...", requestUrl)
    axiosAuth().put(requestUrl, {human_validation_status: newStatus, validated_by_user_id: newStatus == "Checked" ? user.id : null})
      .then( r => {
        fetchValidations()
      })
      .catch(console.log)


  };

  const getRowClassName = (params) => {
    return `${params.row.human_validation_status.toLowerCase()}-row`;
  };

  return (
    <div className="validation-queue-table">
      {validations.length ? (
        <>
          <OliveCard
            fetchParams={{ filters, order }}
            validation={selectedValidation}
            setValidation={setSelectedValidation}
            updateValidationStatus={updateValidationStatus}
            open={selectedValidation && selectedValidation.human_validation_status != "Checked" && selectedValidation.severity != "VALID" }
          />
          <DataGrid
            rows={validations}
            getRowId={(row) => row.id}
            columns={columns}
            disableColumnMenu
            autoHeight
            onRowClick={(params) => {
              const found = validations.find((v) => v.id === params.id);
              setSelectedValidation(found);
            }}
            onColumnVisibilityChange={handleColumnVisibilityChange}
            pageSizeOptions={[20, 50, 100]}
            components={{ Toolbar: GridToolbar }}
            getRowClassName={getRowClassName}
          />
        </>
      ) : loadingValidations ? (
        <Typography variant="h2">
          Loading... <PrimaryColorLoader width={40} height={40} />
        </Typography>
      ) : (
        <Typography style={{ marginTop: 30 }} variant="h2">
          {!validations.length
            ? 'All validations checked! 🎉'
            : 'No validations found!'}
        </Typography>
      )}
    </div>
  );
}